module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['vc'],
    attrs: {
      "id": "app"
    }
  }, [_c('vc-toolbar', {
    attrs: {
      "narrow": "",
      "fixed": "",
      "tag": "header",
      "color": _vm.appColor,
      "application": ""
    }
  }, [_c('vc-toolbar-icon-left', {
    attrs: {
      "icon": "mdi-image"
    }
  }), _vm._v(" "), _c('vc-toolbar-title', [_vm._v(_vm._s(_vm.lang.appTitle))]), _vm._v(" "), _c('vc-toolbar-controls-right', [_c('ul', {
    class: ['app-inline-list', 'app-top-navigation', 'app-inline-block']
  }, _vm._l((_vm.topNavigation), function(link, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": link.to,
        "title": link.hint,
        "target": "_blank"
      }
    }, [_c('vc-icon', {
      attrs: {
        "color": "white"
      }
    }, [_vm._v(_vm._s(link.icon))])], 1)])
  }))])], 1), _vm._v(" "), _c('vc-container', {
    class: ['app-main'],
    attrs: {
      "tag": "main",
      "application": ""
    }
  }, [_c('h2', {
    class: ['headline', 'font-grey', 'font-l-600']
  }, [_vm._v(_vm._s(_vm.lang.appTitle))]), _vm._v(" "), _c('p', [_vm._v("Simple image placeholder component for VueJs for quick visualization during design created by\n        "), _c('a', {
    attrs: {
      "href": "https://wemakesites.net",
      "target": "_blank"
    }
  }, [_vm._v("Martin Ivanov")]), _vm._v(". Easy as setting colors, text and size.")]), _vm._v(" "), _c('h2', {
    class: _vm.fonts.title
  }, [_vm._v("Demos")]), _vm._v(" "), _c('vc-layout', {
    attrs: {
      "spacing": 8
    }
  }, [_c('vc-col', {
    attrs: {
      "span": 6,
      "sm12": "",
      "xs24": ""
    }
  }, [_c('vc-image-placeholder', {
    attrs: {
      "width": "100%",
      "color": _vm.color,
      "label": "auto",
      "background": _vm.background
    }
  })], 1), _vm._v(" "), _c('vc-col', {
    attrs: {
      "span": 6,
      "sm12": "",
      "xs24": ""
    }
  }, [_c('vc-image-placeholder', {
    attrs: {
      "width": "100%",
      "color": _vm.color,
      "label": "auto",
      "background": _vm.background
    }
  })], 1), _vm._v(" "), _c('vc-col', {
    attrs: {
      "span": 6,
      "sm12": "",
      "xs24": ""
    }
  }, [_c('vc-image-placeholder', {
    attrs: {
      "width": "100%",
      "color": _vm.color,
      "label": "auto",
      "background": _vm.background
    }
  })], 1), _vm._v(" "), _c('vc-col', {
    attrs: {
      "span": 6,
      "md12": "",
      "xs24": ""
    }
  }, [_c('vc-image-placeholder', {
    attrs: {
      "width": "100%",
      "color": _vm.color,
      "label": "auto",
      "background": _vm.background
    }
  })], 1), _vm._v(" "), _c('vc-col', {
    attrs: {
      "span": 12,
      "xs24": ""
    }
  }, [_c('vc-image-placeholder', {
    attrs: {
      "width": "100%",
      "color": _vm.color,
      "label": "VueJs",
      "background": _vm.background
    }
  })], 1), _vm._v(" "), _c('vc-col', {
    attrs: {
      "span": 12,
      "xs24": ""
    }
  }, [_c('vc-image-placeholder', {
    attrs: {
      "width": "100%",
      "color": _vm.color,
      "label": "VueJs",
      "background": _vm.background
    }
  })], 1), _vm._v(" "), _c('vc-col', {
    attrs: {
      "span": 24
    }
  }, [_c('vc-image-placeholder', {
    attrs: {
      "width": "100%",
      "color": _vm.color,
      "label": _vm.lang.appTitle,
      "background": _vm.background
    }
  })], 1)], 1), _vm._v(" "), _c('h2', {
    class: _vm.fonts.title
  }, [_vm._v("Installation via NPM/Yarn")]), _vm._v(" "), _c('pre', [_c('code', [_c('span', {
    class: _vm.fonts.grey
  }, [_vm._v("// npm")]), _vm._v("\n» npm i vc-image-placeholder\n"), _c('span', {
    class: _vm.fonts.grey
  }, [_vm._v("// yarn")]), _vm._v("\n» yarn add vc-image-placeholders")])]), _vm._v(" "), _c('h2', {
    class: _vm.fonts.title
  }, [_vm._v("Installation via jsDelivr/UnPkg CDN")]), _vm._v(" "), _c('pre', [_c('code', [_vm._v("\n"), _c('span', {
    class: _vm.fonts.grey
  }, [_vm._v("<!-- jsdelivr cdn -->")]), _vm._v("\n<script src=\"https://cdn.jsdelivr.net/npm/vue@2/dist/vue.min.js\"></script>\n<script src=\"https://cdn.jsdelivr.net/npm/vc-image-placeholder\"></script>\n"), _c('span', {
    class: _vm.fonts.grey
  }, [_vm._v("<!-- unpkg cdn -->")]), _vm._v("\n<script src=\"https://unpkg.com/vue/dist/vue.js\"></script>\n<script src=\"https://unpkg.com/vc-ribbon/dist/lib/vc-ribbon.min.js\"></script>")])]), _vm._v(" "), _c('h2', {
    class: _vm.fonts.title
  }, [_vm._v("Including to your VueJs Project")]), _vm._v(" "), _c('pre', [_c('code', [_c('span', {
    class: _vm.fonts.grey
  }, [_vm._v("// import the module")]), _vm._v("\nimport VcImagePlaceholder from 'vc-image-placeholder'\n"), _c('span', {
    class: _vm.fonts.grey
  }, [_vm._v("// add to Vue")]), _vm._v("\nVue.use(VcRibbon)\n\n"), _c('span', {
    class: _vm.fonts.grey
  }, [_vm._v("// or add it to another Vue component")]), _vm._v("\ncomponents: {\n  VcImagePlaceholder\n}")])]), _vm._v(" "), _c('h2', {
    class: _vm.fonts.title
  }, [_vm._v("Usage")]), _vm._v(" "), _c('p', [_vm._v("Below is the default usage configuration of the component. Refer the the \"Props\" section to learn how\n        to customize VcImagePlaceholder.")]), _vm._v(" "), _c('code', [_vm._v("\n        <vc-image-placeholder />\n      ")]), _vm._v(" "), _c('h2', {
    class: _vm.fonts.title
  }, [_vm._v("Component Props")]), _vm._v(" "), _c('p', [_vm._v("Below is a list of the properties that can be used to customize the look and feel of the image placeholders.")]), _vm._v(" "), _c('vc-list', _vm._l((_vm.props), function(prop, index) {
    return _c('vc-list-item', {
      key: index,
      attrs: {
        "avatar": "code"
      }
    }, [_c('vc-list-item-primary-text', [_vm._v(_vm._s(prop.name))]), _vm._v(" "), _c('vc-list-item-secondary-text', [_vm._v(_vm._s(prop.description))])], 1)
  })), _vm._v(" "), _c('h2', {
    class: _vm.fonts.title
  }, [_vm._v("More Front-end Development Resources")]), _vm._v(" "), _c('vc-list', _vm._l((_vm.resources), function(resource, index) {
    return _c('vc-list-item', {
      key: index,
      attrs: {
        "avatar": "link",
        "icon": "open_in_new",
        "target": "_blank",
        "tag": "a",
        "to": resource.url
      }
    }, [_c('vc-list-item-primary-text', [_vm._v(_vm._s(resource.title))]), _vm._v(" "), _c('vc-list-item-secondary-text', [_vm._v(_vm._s(resource.description))])], 1)
  }))], 1), _vm._v(" "), _c('vc-footer', {
    attrs: {
      "application": "",
      "narrow": "",
      "color": _vm.appColor,
      "align": "right"
    }
  }, [_vm._v("\n      © " + _vm._s(_vm.year) + " "), _c('a', {
    attrs: {
      "href": "https://wemakesites.net",
      "target": "_blank"
    }
  }, [_vm._v("Martin Ivanov")]), _vm._v(" | "), _c('a', {
    attrs: {
      "href": "https://twitter.com/vuecidity",
      "target": "_blank"
    }
  }, [_vm._v("@vuecidity")]), _vm._v(" | "), _c('a', {
    attrs: {
      "href": "https://vuecidity.wemakesites.net",
      "target": "_blank"
    }
  }, [_vm._v("Site built with Vuecidity")])]), _vm._v(" "), _c('vc-social-bar', {
    attrs: {
      "size": "small",
      "button-color": _vm.appColor,
      "fixed": true,
      "items": _vm.social
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ff768254","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module id = 61
// module chunks = 1